__turbopack_context__.v({
  "active": "Navbar-module__fGkAxq__active",
  "buttonWrapper": "Navbar-module__fGkAxq__buttonWrapper",
  "clock": "Navbar-module__fGkAxq__clock",
  "contact": "Navbar-module__fGkAxq__contact",
  "contactIcon": "Navbar-module__fGkAxq__contactIcon",
  "ctas": "Navbar-module__fGkAxq__ctas",
  "logo": "Navbar-module__fGkAxq__logo",
  "menu": "Navbar-module__fGkAxq__menu",
  "menuIcon": "Navbar-module__fGkAxq__menuIcon",
  "mobileOnly": "Navbar-module__fGkAxq__mobileOnly",
  "nav": "Navbar-module__fGkAxq__nav",
  "navbar": "Navbar-module__fGkAxq__navbar",
  "rightSection": "Navbar-module__fGkAxq__rightSection",
  "sound": "Navbar-module__fGkAxq__sound",
  "userSection": "Navbar-module__fGkAxq__userSection",
});
